const module = {
  routes: [
    {
      path: '/employees',
      component: () => import('@/modules/employees/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
